// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updatePromtionForProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitPromotionUpdateApi = createAsyncThunk("hitPromotionUpdateApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + updatePromtionForProfessional;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    showToast(error.response.data.message, "error");
    throw error.response.data;
  }
});

const UpdatePromotionSlice = createSlice({
  name: "updatePromotionReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitPromotionData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitPromotionUpdateApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitPromotionUpdateApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitPromotionUpdateApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitPromotionData } = UpdatePromotionSlice.actions;
export default UpdatePromotionSlice.reducer;
